import { Column } from "@tanstack/react-table";
import { Triangle } from "lucide-react";
import Button from "@/components/atoms/Button";
import clsx from "clsx";

type Props<T> = {
  children: React.ReactNode;
  column: Column<T>;
  sorted?: boolean;
  onSortChange?: (columnId: string, direction: string | undefined) => void;
};

const ColumnHeader = <T extends unknown>({
  children,
  column,
  sorted: isSorted = false,
  onSortChange,
}: Props<T>) => {
  const sorted = column.getIsSorted() || (isSorted ? "asc" : undefined);
  const classes = clsx("p-0 w-full justify-start rounded-none", {
    "text-primary": sorted,
  });
  const upArrowClasses = clsx("absolute top-0 h-2 w-2", {
    "text-primary fill-primary": sorted === "asc",
    "text-slate-500 fill-slate-500": sorted !== "asc",
  });
  const downArrowClasses = clsx("absolute bottom-0 h-2 w-2 rotate-180", {
    "text-primary fill-primary": sorted === "desc",
    "text-slate-500 fill-slate-500": sorted !== "desc",
  });

  const handleClick = () => {
    if (sorted === "asc" || !sorted) {
      column.toggleSorting(sorted === "asc");
    } else {
      column.clearSorting();
    }

    onSortChange?.(column.id, sorted);
  };

  return (
    <Button variant="ghost" className={classes} onClick={handleClick}>
      {children}
      {onSortChange && (
        <div className="relative h-4 w-4 ml-2">
          <Triangle className={upArrowClasses} />
          <Triangle className={downArrowClasses} />
        </div>
      )}
    </Button>
  );
};

export default ColumnHeader;
